import type { Step } from '@de/types/types';

/**
 * Read the normalized step-level traffic source used by DSL context,
 * conversion creation, and Offerings budget filtering.
 */
export function readStepTrafficSource(step?: Step): string | undefined {
  const value = step?.trafficSource;
  return typeof value === 'string' && value.trim() ? value.trim() : undefined;
}
